import { topicsData } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950">热门话题</h2>
          <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-xl mx-auto">
            按题材快速浏览飞飞漫画网漫画全集，发现你感兴趣的漫画类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4 max-w-5xl mx-auto">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#index"
              className={`group flex flex-col items-center gap-2 p-4 md:p-5 rounded-lg transition-all duration-300 hover:-translate-y-1 cursor-pointer no-underline ${
                topic.color === 'primary'
                  ? 'bg-primary-50/70 hover:bg-primary-100/70'
                  : 'bg-accent-50/70 hover:bg-accent-100/70'
              }`}
            >
              <div className={`w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-lg ${
                topic.color === 'primary'
                  ? 'bg-primary-100 text-primary-600 group-hover:bg-primary-200'
                  : 'bg-accent-100 text-accent-600 group-hover:bg-accent-200'
              } transition-colors`}>
                <i className={`${topic.icon} text-lg md:text-xl`}></i>
              </div>
              <span className="font-heading font-semibold text-sm md:text-base text-foreground-900 whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-[11px] md:text-xs text-foreground-400">
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}